(function(){
"use strict";

var slides=[
  {
    text:"All försäljning samlad på ett ställe gör det mycket lättare att se vad som händer och vad som behöver göras härnäst.",
    initials:"GA",
    title:"Gruppansvarig",
    meta:"Överblick & administration"
  },
  {
    text:"Min egen länk och mina egna beställningar gör att jag snabbt ser hur det går utan att hålla koll på lappar.",
    initials:"EL",
    title:"Elev / säljare",
    meta:"Personlig försäljning"
  },
  {
    text:"Det blir tydligt vad som är beställt, hur kunden betalar och vad som behöver delas ut när allt finns på samma plats.",
    initials:"FÖ",
    title:"Förälder",
    meta:"Betalning & utdelning"
  },
  {
    text:"När klassens länkar, QR-koder och beställningar samlas minskar administrationen och det blir enklare att följa gruppen.",
    initials:"LL",
    title:"Lag- eller klassledare",
    meta:"Gruppflöde & uppföljning"
  }
];

var current=0;
var host=null;
var timer=null;
var animating=false;
var ROTATE_MS=6200;

function route(){return location.hash.split("?")[0];}
function isAuthRoute(){
  var r=route();
  return r==="#/login"||r==="#/register";
}
function esc(v){
  return String(v==null?"":v)
    .replace(/&/g,"&amp;")
    .replace(/</g,"&lt;")
    .replace(/>/g,"&gt;")
    .replace(/"/g,"&quot;")
    .replace(/'/g,"&#039;");
}
function stackDepth(index){
  return (index-current+slides.length)%slides.length;
}
function cardMarkup(s,i){
  return '<article class="kp-stack-card" data-kp-card="'+i+'" data-depth="'+stackDepth(i)+'">'+
    '<div class="kp-stack-top">'+
      '<span class="kp-stack-label">✦ Kampansera i praktiken</span>'+
      '<span class="kp-stack-count">'+(i+1)+' / '+slides.length+'</span>'+
    '</div>'+
    '<p>'+esc(s.text)+'</p>'+
    '<div class="who">'+
      '<span class="kp-stack-avatar">'+esc(s.initials)+'</span>'+
      '<div><b>'+esc(s.title)+'</b><span>'+esc(s.meta)+'</span></div>'+
    '</div>'+
    '<div class="kp-stack-footer">'+
      '<span class="kp-stack-auto"><span class="kp-stack-auto-dot"></span>Byter automatiskt</span>'+
      '<button type="button" class="kp-stack-next" data-kp-next>Visa nästa →</button>'+
    '</div>'+
  '</article>';
}
function wrapMarkup(){
  return '<div class="kp-stack-wrap">'+slides.map(cardMarkup).join("")+'</div>';
}
function finalStyle(depth){
  if(depth===0)return {transform:"translate3d(0,0,0) rotate(0deg) scale(1)",opacity:"1",zIndex:"4"};
  if(depth===1)return {transform:"translate3d(14px,13px,0) rotate(-2deg) scale(.965)",opacity:".96",zIndex:"3"};
  if(depth===2)return {transform:"translate3d(28px,27px,0) rotate(2deg) scale(.93)",opacity:".86",zIndex:"2"};
  return {transform:"translate3d(38px,38px,0) rotate(-1deg) scale(.90)",opacity:"0",zIndex:"1"};
}
function applyStyles(){
  if(!host)return;
  host.querySelectorAll(".kp-stack-card").forEach(function(card){
    var i=Number(card.getAttribute("data-kp-card"));
    var d=stackDepth(i);
    var s=finalStyle(d);
    card.dataset.depth=String(d);
    card.style.transform=s.transform;
    card.style.opacity=s.opacity;
    card.style.zIndex=s.zIndex;
    card.style.pointerEvents=d===0?"auto":"none";
  });
}
function restartTimer(){
  if(timer){clearInterval(timer);timer=null;}
  timer=setInterval(function(){
    if(document.hidden||!isAuthRoute()||!host||!document.body.contains(host)||animating)return;
    advance(false);
  },ROTATE_MS);
}
function waapi(el,frames,options){
  if(el&&el.animate){
    try{return el.animate(frames,options).finished.catch(function(){});}catch(e){}
  }
  return new Promise(function(resolve){
    if(!el){resolve();return;}
    var last=frames[frames.length-1]||{};
    Object.keys(last).forEach(function(k){el.style[k]=last[k];});
    setTimeout(resolve,options.duration||500);
  });
}
function advance(manual){
  if(!host||animating)return;
  var outgoing=host.querySelector('[data-kp-card="'+current+'"]');
  var nextIndex=(current+1)%slides.length;
  var next=host.querySelector('[data-kp-card="'+nextIndex+'"]');
  var third=host.querySelector('[data-kp-card="'+((current+2)%slides.length)+'"]');
  var fourth=host.querySelector('[data-kp-card="'+((current+3)%slides.length)+'"]');
  if(!outgoing||!next)return;

  animating=true;
  var jobs=[
    waapi(outgoing,[
      {transform:"translate3d(0,0,0) rotate(0deg) scale(1)",opacity:1},
      {transform:"translate3d(86px,-18px,0) rotate(8deg) scale(.985)",opacity:0}
    ],{duration:560,easing:"cubic-bezier(.22,1,.36,1)",fill:"forwards"}),
    waapi(next,[
      {transform:"translate3d(14px,13px,0) rotate(-2deg) scale(.965)",opacity:.96},
      {transform:"translate3d(0,0,0) rotate(0deg) scale(1)",opacity:1}
    ],{duration:560,easing:"cubic-bezier(.22,1,.36,1)",fill:"forwards"}),
    waapi(third,[
      {transform:"translate3d(28px,27px,0) rotate(2deg) scale(.93)",opacity:.86},
      {transform:"translate3d(14px,13px,0) rotate(-2deg) scale(.965)",opacity:.96}
    ],{duration:560,easing:"cubic-bezier(.22,1,.36,1)",fill:"forwards"}),
    waapi(fourth,[
      {transform:"translate3d(38px,38px,0) rotate(-1deg) scale(.90)",opacity:0},
      {transform:"translate3d(28px,27px,0) rotate(2deg) scale(.93)",opacity:.86}
    ],{duration:560,easing:"cubic-bezier(.22,1,.36,1)",fill:"forwards"})
  ];

  Promise.all(jobs).then(function(){
    current=nextIndex;
    host.querySelectorAll(".kp-stack-card").forEach(function(card){
      try{card.getAnimations().forEach(function(a){a.cancel();});}catch(e){}
      card.style.removeProperty("transform");
      card.style.removeProperty("opacity");
      card.style.removeProperty("z-index");
      card.style.removeProperty("pointer-events");
    });
    applyStyles();
    animating=false;
    if(manual)restartTimer();
  });
}
function bind(){
  if(!host||host.dataset.kpStackBound==="1")return;
  host.dataset.kpStackBound="1";
  host.addEventListener("click",function(e){
    var nextBtn=e.target.closest&&e.target.closest("[data-kp-next]");
    if(nextBtn){advance(true);}
  });
}
function stop(){
  if(timer){clearInterval(timer);timer=null;}
  animating=false;
}
function sync(){
  if(!isAuthRoute()){stop();host=null;return;}
  var quote=document.querySelector(".auth-left .al-quote");
  if(!quote)return;
  if(host!==quote){
    stop();
    host=quote;
    current=0;
    host.innerHTML=wrapMarkup();
    bind();
    applyStyles();
    restartTimer();
  }else{
    bind();
    if(!timer)restartTimer();
  }
}
document.addEventListener("visibilitychange",function(){
  if(document.hidden)stop();
  else if(isAuthRoute())sync();
});
window.addEventListener("hashchange",function(){setTimeout(sync,120);});
var app=document.getElementById("app");
if(app&&window.MutationObserver){
  new MutationObserver(function(){setTimeout(sync,80);}).observe(app,{childList:true,subtree:true});
}
setTimeout(sync,450);
})();